var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 306,
    viewBox: "0 0 429 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 304.729,
    rx: 4,
    fill: "#175C4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.3627 250.146C89.3627 283.805 62.0521 305.198 28.3627 305.198C-5.32666 305.198 0.362783 305.305 0.362698 250.146C0.362623 201.389 -5.32664 189.2 28.3627 189.2C62.0521 189.2 89.3627 216.486 89.3627 250.146Z",
    fill: "#F98700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.657 38.7907C362.255 15.7674 381.86 0.787619 406.358 0.359999C430.857 -0.067622 426.718 -0.0684268 427.377 37.661C427.959 71.011 432.242 79.2762 407.743 79.7039C383.245 80.1315 363.059 61.814 362.657 38.7907Z",
    fill: "#F98700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroimg);
export default __webpack_public_path__ + "static/media/heroimg.ef0a7c5a2f979966f354b5e8c19d40aa.svg";
export { ForwardRef as ReactComponent };